import type { Ref } from 'react';
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import styles from '../../pages/SampleManager.module.css';

interface SampleManagerCreateActionsProps {
  createButtonRef?: Ref<HTMLButtonElement>;
  createDisabled?: boolean;
  /** disabled 時の title / 補足（保管庫未登録など） */
  createDisabledTitle?: string;
  onCreate: () => void;
  showTourButton?: boolean;
  onStartTour?: () => void;
  /**
   * フィルター行 trailing 向け:
   * - compact: モバイルはアイコンのみ、xxl+ は文言付き
   * - ツアーは md 未満では非表示（検索欄を優先。空一覧は自動ツアー）
   */
  compact?: boolean;
  className?: string;
}

/** 新規登録 + ツアー（サンプル一覧フィルター行で使用） */
export default function SampleManagerCreateActions({
  createButtonRef,
  createDisabled = false,
  createDisabledTitle,
  onCreate,
  showTourButton = false,
  onStartTour,
  compact = false,
  className = '',
}: SampleManagerCreateActionsProps) {
  const { t } = useTranslation();
  // visible / aria = short、title = モーダル見出しと同型（新規サンプル）
  const createFull = t('sample.modal_create_title', {
    defaultValue: t('sample.new_registration'),
  });
  const createShort = t('sample.new_registration_short', { defaultValue: '新規' });
  const title = createDisabled && createDisabledTitle ? createDisabledTitle : createFull;

  return (
    <div className={`${styles.pageActions}${className ? ` ${className}` : ''}`.trim()}>
      <button
        ref={createButtonRef}
        type="button"
        className={`btn btn-primary shadow-sm w-auto ${styles.createBtn}${compact ? ` ${styles.createBtnCompact}` : ''}`}
        disabled={createDisabled}
        onClick={onCreate}
        title={title}
        aria-label={createDisabled && createDisabledTitle ? createDisabledTitle : createShort}
      >
        <i className={`fas fa-plus${compact ? '' : ' me-2'}`} aria-hidden="true" />
        {compact ? (
          <span className="d-none d-xxl-inline ms-1" aria-hidden="true">
            {createShort}
          </span>
        ) : (
          <span>{createShort}</span>
        )}
      </button>
      {showTourButton && onStartTour ? (
        <Button
          variant="outline-secondary"
          size="sm"
          className={`d-none d-md-inline-flex align-items-center justify-content-center flex-shrink-0 w-auto ${styles.tourBtn}`}
          onClick={onStartTour}
          title={t('sample.start_tour')}
          aria-label={t('sample.start_tour')}
        >
          <i className="fas fa-compass" aria-hidden="true" />
        </Button>
      ) : null}
    </div>
  );
}
